import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { useEffect, useRef } from 'react';
import deepEqual from 'fast-deep-equal';
/**
 * Hook for callback from prop.
 */
export var useCallbackProp = function (cb) {
    var cbRef = useRef(cb);
    useEffect(function () {
        cbRef.current = cb;
    }, [cb]);
    return cbRef;
};
/**
 * `useEffect` hook that compare dependencies deeply.
 */
export var useDeepEffect = function (effect, deps) {
    var ref = useRef(undefined);
    if (!ref.current || !deepEqual(deps, ref.current)) {
        ref.current = deps;
    }
    useEffect(effect, ref.current);
};
/**
 * Check current env SSR.
 */
export function checkSSR() {
    return typeof window === 'undefined';
}
/**
 * Inject script.
 */
export function scriptInjector(scriptUrl, verbose) {
    if (verbose === void 0) { verbose = false; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (document.querySelector("[src=\"" + scriptUrl + "\"]")) {
                return [2 /*return*/];
            }
            debugLogger(verbose, 'Injecting SDK script...');
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var el = document.createElement('script');
                    el.src = scriptUrl;
                    el.async = true;
                    el.defer = true;
                    el.onload = function () {
                        resolve();
                        el.onload = null;
                        el.onerror = null;
                    };
                    el.onerror = function () {
                        reject(new Error('Fail to inject SDK script.'));
                        el.onload = null;
                        el.onerror = null;
                    };
                    document.head.appendChild(el);
                })];
        });
    });
}
/**
 * Log warning.
 */
export function warnLogger() {
    var msgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        msgs[_i] = arguments[_i];
    }
    // eslint-disable-next-line no-console
    console.warn.apply(console, __spreadArray(['[ReactChannelIO]'], __read(msgs)));
}
/**
 * Log debugging.
 */
export function debugLogger(verbose) {
    var msgs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        msgs[_i - 1] = arguments[_i];
    }
    if (!verbose) {
        return;
    }
    // eslint-disable-next-line no-console
    console.debug.apply(console, __spreadArray(['⚙️ [ReactChannelIO - debug]'], __read(msgs)));
}
